import React, {Component} from 'react';
import {
    StoragePicList,
    StorageAudioList,
    StorageContributeList, StorageOtherList, PluginStoragePicList,
    StorageRecycleList,
    StorageVideoList
} from "../components/storageList";
import {getStorageDirectoryList} from "../actions/storageList";
import {connect} from "react-redux";

class StorageList extends Component {

    constructor(props){
        super(props);

        this.state = {
            directoryDatasource : [],
            fileDatasource: [],
            currentId: "",
        };

        getStorageDirectoryList(this.props.match.params.currentId, (dataSource)=>{
            this.setState({
                directoryDatasource: dataSource.directorys,
                fileDatasource: dataSource.files,
                currentId: this.props.match.params.currentId,
            })
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        getStorageDirectoryList(nextProps.match.params.currentId, (dataSource)=>{
            this.setState({
                directoryDatasource: dataSource.directorys,
                fileDatasource: dataSource.files,
                currentId: nextProps.match.params.currentId,
                navigateStatus: nextProps.navigateStatus
            })
        });
    }

    render() {

        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';

        if(this.props.match.params.resourceComponent === "StoragePicList"){
            return <StoragePicList {...this.state}  {...this.props} newSecondSelectColor={newSecondSelectColor} />;
        }else if(this.props.match.params.resourceComponent === "StorageAudioList"){
            return <StorageAudioList {...this.state}  {...this.props} newSecondSelectColor={newSecondSelectColor}/>;
        }else if(this.props.match.params.resourceComponent === "StorageVideoList"){
            return <StorageVideoList {...this.state}  {...this.props} newSecondSelectColor={newSecondSelectColor} />;
        }else if(this.props.match.params.resourceComponent === "StorageOtherList"){
            return <StorageOtherList {...this.state}  {...this.props}  newSecondSelectColor={newSecondSelectColor}/>;
        }else if(this.props.match.params.resourceComponent === "StorageRecycleList"){
            return <StorageRecycleList {...this.state}  {...this.props} title={"回收站"} newSecondSelectColor={newSecondSelectColor} />;
        }else if(this.props.match.params.resourceComponent === "PluginStoragePicList"){
            return <PluginStoragePicList {...this.state}   {...this.props} newSecondSelectColor={newSecondSelectColor}/>;
        }else{
            return <StorageContributeList {...this.state}  {...this.props} newSecondSelectColor={newSecondSelectColor}/>
        }
    }
}

function mapStateToProps(state){
    return {
        config: state.systemReducer.config,
        navigateStatus:state.systemReducer.navigateStatus,
    }
}

export default connect(mapStateToProps)(StorageList);